export const RESIZE_CANVAS = 'RESIZE_CANVAS';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/canvas.js